var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "spaceLeft pool-status",
      class: {
        success: +_vm.statusRearly == 2,
        failed: +_vm.statusRearly == 3,
        ing: +_vm.statusRearly == 1,
      },
    },
    [
      +_vm.statusRearly == 2
        ? _c("img", {
            attrs: {
              src: require("@/assets/image/governance/polling-icon-1.png"),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      +_vm.statusRearly == 3
        ? _c("img", {
            attrs: {
              src: require("@/assets/image/governance/polling-icon-2.png"),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "pool-status-text" }, [
        _vm._v(_vm._s(_vm.statusMap["status_" + _vm.statusRearly])),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }